  /*=========================================================================================
  File Name: state.js
  Description: App State
  ----------------------------------------------------------------------------------------
  Item Name: App State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    exception : {
        message : null,
        isCatched : false
    },
    isLoadingData : false
}